import Serve from "./Serve";
export default Serve;
